/* unplugin-vue-components disabled */import { render } from "./SpareParts.vue?vue&type=template&id=d273e85e&scoped=true&ts=true"
import script from "./SpareParts.vue?vue&type=script&lang=ts"
export * from "./SpareParts.vue?vue&type=script&lang=ts"

import "./SpareParts.vue?vue&type=style&index=0&id=d273e85e&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d273e85e"]])

export default __exports__